(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningItemFilesResource", ["$resource", learningItemFilesResource]);
    function learningItemFilesResource($resource) {
        return $resource("/api/learningItemFiles/:code/:id/:action", { code: "@code", id: "@id", action: "@action" }, {
            update: {
                method: "PUT"
            },
            deleteFile: {
                method: "DELETE"
            },
            replaceFile: {
                method: "POST",
                params: { action: "replace" }
            }
        });
    }
}());
